import { Button, ClickEvent, DropdownSelectionEvent, LookupModelSelectionEvent, ScreenStack, Snackbar, TextboxProps } from "@mcleod/components";
import { AutogenLayoutReplaceSalespersonOpsUser } from "./autogen/AutogenLayoutReplaceSalespersonOpsUser";
import { Api } from "@mcleod/core";
import { ReplaceUserResultModal } from "./ReplaceUserResultModal";

export class ReplaceSalespersonOpsUser extends AutogenLayoutReplaceSalespersonOpsUser {
    textboxReplaceAfterDropdownSelection(event: DropdownSelectionEvent): void {
        this.textboxExisting.enabled = event.hasSelection();
        this.textboxReplaceWith.enabled = event.hasSelection();

        const type = event.selection?.value ?? null;
        if (type == null) {

            this.textboxExisting.clear();
            this.textboxReplaceWith.clear();
            this.buttonExecute.enabled = false;
        } else if (type === "S") {
            const props: Partial<TextboxProps> = {
                quickInfoLayout: "lme/ar/SalespersonQuickInfo",
                lookupModel: "lme/ar/salesperson-lookup",
                lookupModelDisplayField: "name",
                lookupModelLayout: "lme/ar/SalespersonLookup",
                lookupModelResultField: "id"
            };
            this.textboxExisting.setProps(props);
            this.textboxReplaceWith.setProps(props);
        } else if (type === "O") {
            const props: Partial<TextboxProps> = {
                quickInfoLayout: "common/UserQuickInfo",
                lookupModel: "common/users",
                lookupModelDisplayField: "name",
                lookupModelLayout: "common/UserLookup",
                lookupModelResultField: "id"
            };
            this.textboxExisting.setProps(props);
            this.textboxReplaceWith.setProps(props);
        }
    }


    textboxExistingOnLookupModelSelection(event: LookupModelSelectionEvent): void {
        this.syncButtonExecute();
        if (event.hasSelection()) {
            this.sourceReplaceUser.executeValidatedSearch();
        }
    }

    textboxReplaceWithOnLookupModelSelection(event: LookupModelSelectionEvent): void {
        this.syncButtonExecute();
    }

    private syncButtonExecute(): void {
        this.buttonExecute.enabled = !this.textboxExisting.isEmpty() && !this.textboxReplaceWith.isEmpty();
    }

    async buttonExecuteOnClick(event: ClickEvent) {
        const button = event.target as Button;
        button.busy = true;
        const type = this.textboxReplace.selectedItem?.displayValue ?? null;
        const loading = Snackbar.showDownloadSnackbar(
            "Action in Progress",
            `Replacing ${type}...`,
            { persist: true, targetPanel: ScreenStack.getSnackbarTarget() }
        );
        try {
            const result = await Api.post(this.sourceReplaceUser.url, this.sourceReplaceUser.searchRow.data);
            ReplaceUserResultModal.showModal(
                `Replace ${type} Results`,
                result?.data?.[0]?.updated ?? [],
                result?.data?.[0]?.failed ?? []
            );
            this.sourceReplaceUser.executeValidatedSearch();
        } finally {
            loading.dismiss();
            button.busy = false;
        }
    }
}